import alerts from './modules/alerts';
import areas from './modules/areas';
import auth from './modules/auth';
import legacy from './modules/legacy';
import nav from './modules/nav';
import notificacoes from './modules/notificacoes';
import sistemas from './modules/sistemas';

export default { alerts, areas, auth, legacy, nav, notificacoes, sistemas };